import type { DockviewApi } from 'dockview';

/**
 * Module-level handles that decouple the controller from React/Dockview: the
 * controller talks to Dockview through this ref, and the drag layer reads the
 * live workspace element for pointer→workspace coordinate mapping.
 */
let dockApi: DockviewApi | null = null;
let workspaceEl: HTMLElement | null = null;
let tabStripEl: HTMLElement | null = null;

export const setDockApi = (api: DockviewApi | null): void => {
  dockApi = api;
};
export const getDockApi = (): DockviewApi | null => dockApi;

/** The stage (floating layer): pointer→workspace coordinate origin. */
export const setWorkspaceEl = (el: HTMLElement | null): void => {
  workspaceEl = el;
};
export const getWorkspaceEl = (): HTMLElement | null => workspaceEl;

/**
 * An explicit, always-present overlay spanning the tab strip. Used as the
 * tab-dock hit-test geometry (client coords) so docking is precise, works with
 * zero tabs, and — crucially — a document/panel BODY never qualifies as a tab
 * target (only this strip does).
 */
export const setTabStripEl = (el: HTMLElement | null): void => {
  tabStripEl = el;
};
export const getTabStripEl = (): HTMLElement | null => tabStripEl;
